// Generated with util/create-component.js
import { styled } from "@mui/material";

export const StyledDiv = styled("div")(({ theme }) => {
    return {
        "&.editableRootShadow": {
            border: `1px solid #DFE7EE`,
        },
        ".editableTextbox": {
            minHeight: "150px",
            textTransform: "none",
            padding: "3px 3px 15px 5px",
            borderRadius: "0 0 7px 7px",
        },
        ".readOnlyTextbox": {
            minHeight: "80px",
            maxHeight: "300px",
            overflow: "auto",
            textTransform: "none",
            padding: "0 .5rem .75rem .5rem",
            borderRadius: 4,
        },
        ".readOnlyQuestionCard": {
            "& p": {
                margin: 0,
            },
        },
        ".floatButtonRight": {
            float: "right",
        },
        ".buttonSaveCancel": {
            minHeight: 100,
        },
    };
});
